import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Plus, Trash2, Layers } from "lucide-react";

export default function Segments() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ name: "", tags: "", location: "", lead_status: "" });

  const load = async () => { const r = await api.get("/segments"); setItems(r.data); };
  useEffect(() => { load(); }, []);

  const create = async () => {
    const filters = {};
    if (f.tags) filters.tags = f.tags.split(",").map(s=>s.trim()).filter(Boolean);
    if (f.location) filters.location = f.location;
    if (f.lead_status) filters.lead_status = f.lead_status;
    try { await api.post("/segments", { name: f.name, filters }); toast.success("Segment created"); setOpen(false); setF({name:"",tags:"",location:"",lead_status:""}); load(); }
    catch { toast.error("Failed"); }
  };

  return (
    <div className="p-4 lg:p-6 space-y-4 max-w-6xl mx-auto">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Segments</h1>
          <p className="text-sm text-slate-500">Group contacts for targeted campaigns</p>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild>
            <Button className="bg-emerald-600 hover:bg-emerald-700" data-testid="new-segment-button"><Plus className="w-4 h-4 mr-1"/>New Segment</Button>
          </DialogTrigger>
          <DialogContent className="bg-white">
            <DialogHeader><DialogTitle>Create segment</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div><Label>Name</Label><Input value={f.name} onChange={(e)=>setF({...f,name:e.target.value})} data-testid="segment-name-input"/></div>
              <div><Label>Tags (comma)</Label><Input value={f.tags} onChange={(e)=>setF({...f,tags:e.target.value})} placeholder="hyd, 3bhk" data-testid="segment-tags-input"/></div>
              <div><Label>Location contains</Label><Input value={f.location} onChange={(e)=>setF({...f,location:e.target.value})} data-testid="segment-location-input"/></div>
              <div><Label>Lead status</Label><Input value={f.lead_status} onChange={(e)=>setF({...f,lead_status:e.target.value})} placeholder="new, interested…" data-testid="segment-status-input"/></div>
            </div>
            <DialogFooter><Button onClick={create} className="bg-emerald-600 hover:bg-emerald-700" data-testid="save-segment-button">Create</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((s) => (
          <Card key={s.id} className="p-5 border-slate-200 hover:shadow-md transition-shadow" data-testid={`segment-card-${s.id}`}>
            <div className="flex items-start justify-between">
              <div className="w-9 h-9 rounded-lg bg-emerald-50 flex items-center justify-center text-emerald-700"><Layers className="w-4 h-4"/></div>
              <Button variant="ghost" size="icon" onClick={async()=>{await api.delete(`/segments/${s.id}`); load();}} data-testid={`delete-segment-${s.id}`}>
                <Trash2 className="w-4 h-4 text-rose-500"/>
              </Button>
            </div>
            <div className="mt-3 font-semibold text-slate-900">{s.name}</div>
            <div className="mt-1 text-sm text-slate-500">{s.contact_count ?? 0} contacts</div>
            <div className="mt-3 flex flex-wrap gap-1">
              {(s.filters?.tags || []).map(t => <Badge key={t} variant="outline" className="text-[10px]">{t}</Badge>)}
              {s.filters?.location && <Badge variant="outline" className="text-[10px]">📍 {s.filters.location}</Badge>}
            </div>
          </Card>
        ))}
        {items.length === 0 && <div className="text-slate-500 col-span-full text-center p-12">No segments yet</div>}
      </div>
    </div>
  );
}
